import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue";
export default {
  name:'GerenciamentoMenu',
  components: { 
    gCard,
    gForm,
    'g-button': gButton
  }, 

  props: { },

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { }, 

};